let state = {
    PreviewSections : [
        [
            {
                className:"right",
                title: "Новая конструкция твитера C-CAM",
                text1: `Специально для серии Silver 7G разработан новый дюймовый твитер из патентованного алюминиево-магниевого сплава с керамическим покрытием (C-CAM).`,
                text2: `Он имеет позолоченный купол и оснащён обновлённым волноводом UD II (Uniform Dispersion Waveguide II). Такая конструкция обеспечивает равномерное рассеяние и более естественную передачу верхних частот спектра – вплоть до 35 кГц. Особый, тщательно просчитанный рисунок защитной решётки твитера также способствует улучшению характеристик звучания. Помимо прочего, можно отметить совершенно новую структуру магнита и устройство задней камеры.`,
                src: "/img/pic1.png",
                alt: "Новая конструкция твитера C-CAM"
            },
            {
                className:"left",
                title: "Диффузор RST II новой геометрии",
                text1: `Поверхность диффузоров СЧ/НЧ-динамиков, выполненная по фирменной технологии RST II (Rigid Surface Technology II), отличается хорошо заметными шестиугольными углублениями.`,
                text2:`Подобная геометрия ещё более повышает прочность поверхности мембраны из того же C-CAM, что гарантирует равномерность звучания, низкий уровень искажений, высокую мощность и отличную направленность звучания. Эти динамики способны на продолжительную работу в режиме повышенной громкости без снижения качества звука.`,
                src: "/img/pic2.png",
                alt: "Диффузор RST II новой геометрии"
            },
            {
                className:"right",
                title: "Усовершенствованный разделительный фильтр",
                text1: `Кроссовер новой конструкции обеспечивает моделям линейки Silver идеальное согласование излучателей по тональному балансу.`,
                text2:`Распределение частотной полосы музыкального сигнала между твитером и вуфером – это, своего рода, искусство. Сглаженное и контролируемое разделение частот между драйверами – вот исчерпывающее описание работы этого важнейшего элемента акустической системы Monitor Audio.`,
                src: "/img/pic3.png",
                alt: "Усовершенствованный разделительный фильтр"
            },
            {
                className:"left",
                title: "Новые опоры напольных колонок",
                text1: `Напольные модели оснащаются массивными выносными опорами из ABS-полимера с металлическими накладками.`,
                text2:`Ножки с шипами обновлённой конфигурации обеспечивают корпусу колонки абсолютную устойчивость на ковровом покрытии или твёрдом полу.`,
                src: "/img/pic4.png",
                alt: "Новые опоры напольных колонок"
            },
            {
                className:"right",
                title: "Специальная акустическая система для Dolby Atmos®",
                text1: `Специальная акустическая система
                для Dolby Atmos®
                Колонки Silver AMS 7G с технологией Dolby Atmos®, создавая яркую трёхмерную панораму звучания, делает ощущения от просмотра фильмов максимально реалистичными. Со специально созданным аудио-видео контентом степень детализации практически не ограничена.`,
                text2:`Дальние раскаты грома, падающие капли дождя, зонт, раскрывающийся у вас над головой. С колонками Dolby Atmos®, вы услышите всё до мельчайших подробностей. Пространственное звучание кинотеатральной системы дополняется новым измерением.`,
                src: "/img/pic5.png",
                alt: "Специальная акустическая система для Dolby Atmos®"
            }
        ]
    ],
    Sections : [
        [
            {
                id: "ShelfAcoustics",
                h1: "Полочная акустика",
                href: "https://www.pult.ru/product/polochnaya-akustika-monitor-audio-silver-50-7g-satin-white",
                className:"right",
                title: "Monitor Audio Silver 50 7G",
                text: `Monitor Audio Silver 50 7G - качество звучания большой акустики в небольшом форм-факторе. Полочники Silver 50 7G привносят точность звучания студийных мониторов в вашу гостиную, при этом их дизайн позволит им отлично вписаться в ваш домашний интерьер. Вам все это, позволит насладиться глубоким басом и потрясающим звуком от акустики небольших размеров.`,
                src: [{src:"/img/img11.png"},{src:"/img/img1.png"},{src:"/img/img13.png"},{src:"/img/img14.png"}],
                priceNew: "69 990 ₽/пара",
                alt: "Monitor Audio Silver 50 7G",
                initialSlide: 1
            },
            {
                href: "https://www.pult.ru/product/polochnaya-akustika-monitor-audio-silver-100-7g-satin-white",
                className:"left",
                title: "Monitor Audio Silver 100 7G",
                text: `Красивая полочная акустика Monitor Audio Silver 100 7G, выходит за рамки обычного. Благодаря технологии изготовления СЧ/НЧ-динамика RST II (Rigid Surface Technology II) и новому твитеру в акустике устраняются различные искажения. Поэтому даже когда вы нагружаете ее до предела, звук остается четким и контролируемым.`,
                priceNew: "89 990 ₽/пара",
                src: [{src:"/img/img2.png"},{src:"/img/img22.png"},{src:"/img/img23.png"},{src:"/img/img24.png"}],
                alt: "Monitor Audio Silver 100 7G",
                initialSlide: 0
            }
        ],
        [
            {
                id: "FloorAcoustics",
                href: "https://www.pult.ru/product/napolnaya-akustika-monitor-audio-silver-200-7g-satin-white",
                h1: `Напольная акустика`,
                className:"right",
                title: "Monitor Audio Silver 200 7G",
                text: `Изящные, компактные и элегантные колонки Monitor Audio Silver 200 7G оснащены новыми СЧ/НЧ-динамиками произведенными по технологии RST II обеспечивающей максимальную точность воспроизведения звука. Эти колонки идеально подходят для большинства комнат и созданы, чтобы сделать необычный звук частью вашей повседневной жизни.`,
                src: [{src:"/img/img31.png"},{src:"/img/img32.png"},{src:"/img/img33.png"},{src:"/img/img3.png"}],
                priceNew: "139 900 ₽/пара",
                alt: "Monitor Audio Silver 200 7G",
                initialSlide: 3
            },
            {
                    href: "https://www.pult.ru/product/napolnaya-akustika-monitor-audio-silver-300-7g-satin-white",
                    className:"left",
                    title: "Monitor Audio Silver 300 7G",
                    text: `Напольная акустика Monitor Audio Silver 300 7G отличается отделкой из натурального шпона для того, чтобы акустика имела прекрасный внешний вид, а так же динамиками выполненными по технологии Rigid Surface Technology (RST) II для максимально естественного звучания. Колонка разработана для уменьшения искажений, поэтому, когда вы максимально нагружаете акустику, ее звучание остается четким и ясным.`,
                    priceNew: "169 900 ₽/пара",
                    src: [{src:"/img/img41.png"},{src:"/img/img42.png"},{src:"/img/img43.png"},{src:"/img/img44.png"}],
                    alt: "Monitor Audio Silver 300 7G",
                    initialSlide: 2
            },
            {
                href: "https://www.pult.ru/product/napolnaya-akustika-monitor-audio-silver-500-7g-satin-white",
                className:"right",
                title: "Monitor Audio Silver 500 7G",
                text: `Мощный бас. Отличный частотный отклик на высоких и средних частотах. Красивый внешний вид. Нетрудно сказать, что делает акустику Monitor Audio Silver 500 7G особенной, но трудно оценить, насколько это все имеет значение, пока вы сами не услышите ее звучание.`,
                src: [{src:"/img/img51.png"},{src:"/img/img52.png"},{src:"/img/img53.png"},{src:"/img/img54.png"}],
                priceNew: "199 900 ₽/пара",
                alt: "Monitor Audio Silver 500 7G",
                EISA: "/img/EISA.png",
                initialSlide: 1
            }

        ],
        [
            {       id: "CenterChannelAcoustics",
                    h1: "Акустика центрального канала",
                    href: "https://www.pult.ru/product/akustika-tsentralnogo-kanala-monitor-audio-silver-c250-7g-satin-white",
                    className:"left",
                    title: "Monitor Audio Silver C250 7G",
                    text: `Благодаря Monitor Audio Silver C250 7G, находящегося в составе вашего домашнего кинотеатра, ваши любимые фильмы зазвучат лучше, чем когда-либо раньше. Центральный канал обеспечивает живой кинематографический звук, который вы можете слышать и чувствовать, делая культовые моменты в фильмах просто незабываемыми.`,
                    priceNew: "74 900 ₽/пара",
                    src: [{src:"/img/img61.png"},{src:"/img/img62.png"},{src:"/img/img63.png"},{src:"/img/img64.png"}],
                    alt: "Monitor Audio Silver C250 7G",
                    initialSlide: 0
            }
        ],
        [
            {       id: "WallAcoustics",
                    h1: "Настенная акустика",
                    href: "https://www.pult.ru/product/nastennaya-akustika-monitor-audio-silver-fx-7g-satin-white",
                    className:"right",
                    title: "Monitor Audio Silver FX 7G",
                    text: `Изящные и минималистичные колонки Silver FX 7G станут идеальным дополнением к вашему домашнему кинотеатру. Благодаря обновленным динамикам и новому дизайну кроссовера, эта акустика серии Silver Series звучит намного лучше своих предшественников.`,
                    priceNew: "74 900 ₽/пара",
                    src: [{src:"/img/img71.png"},{src:"/img/img7.png"}],
                    alt: "Monitor Audio Silver FX 7G",
                    initialSlide: 1
            }
        ],
        [
                {   id: "AcousticsDolby",    
                    h1: "Акустика Dolby",
                    href: "https://www.pult.ru/product/akustika-dolby-atmos-monitor-audio-silver-ams-7g-satin-white",
                    className:"left",
                    title: "Atmos Monitor Audio Silver AMS 7G",
                    text: `Copy
                    Monitor Audio Silver AMS 7G для систем Dolby Atmos® перемещает вас прямо в фильм или песню, создавая трехмерную звуковую сцену с беспрецедентным реализмом. Для специально созданного контента нет предела возможной детализации.`,
                    priceNew: "79 900 ₽/пара",
                    src: [{src:"/img/img8.png"},{src:"/img/img82.png"}],
                    alt: "Atmos Monitor Audio Silver AMS 7G",
                    initialSlide: 0
            }
        ],
        [
            {       
                    id: "Subwoofer",
                    h1: "Сабвуфер",
                    href: "https://www.pult.ru/product/sabvufer-monitor-audio-silver-w-12-high-gloss-black",
                    className:"right",
                    title: "Monitor Audio Silver W12 (6G)",
                    text: `Активный сабвуфер Silver W-12 обеспечивает громоподобный бас, благодаря своему 300-мм длинноходному динамику, который оснащён чрезвычайно мощной магнитной системой и массивной звуковой катушкой, обеспечивающими огромную мощность в компактном герметичном корпусе. `,
                    priceNew: "119 990 ₽",
                    src: [{src:"/img/img91.png"},{src:"/img/img9.png"}],
                    alt: "Monitor Audio Silver W12 (6G)",
                    initialSlide: 1
            }
        ],

    ],
    FooterList : [
        [
            {   id: "2item",
                idCol: "2Col",
                title: "Каталог",
                href: "https://www.pult.ru/main/akustika",
                text: "Акустика"
            },
            {
                href: "https://www.pult.ru/main/hi-fi/",
                text: "Hi-Fi"
            },
            {
                href: "https://www.pult.ru/main/vinil/",
                text: "Винил"
            },
            {
                href: "https://www.pult.ru/main/naushniki/",
                text: "Наушники"
            },
            {
                href: "https://www.pult.ru/main/televizory/",
                text: "Телевизоры"
            },
            {
                href: "https://www.pult.ru/main/proektory/",
                text: "Проекторы"
            }
        ],
        [
            {   id: "1item",
                idCol: "1Col",
                title: "PULT.RU",
                href: "https://www.pult.ru/main/akustika",
                text: "О компании"
            },
            {
                href: "https://www.pult.ru/contacts/",
                text: "Контакты"
            },
            {
                href: "https://www.pult.ru/contacts/",
                text: "Салоны"
            },
            {
                href: "https://www.pult.ru/news/",
                text: "Новости"
            },
            {
                href: "https://www.pult.ru/articles/",
                text: "Обзоры и статьи"
            }
        ],
    ]
}
export default state;